import Link from 'next/link';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ArrowRight, Star } from 'lucide-react';
import { AccessCards } from './access-cards';
import type { ReactElement } from 'react';

interface HeroSectionProps {
  isAuthenticated: boolean;
  showAccessCards?: boolean;
  children?: React.ReactNode;
}

export function HeroSection({ isAuthenticated, showAccessCards = true, children }: HeroSectionProps): ReactElement {
  return (
    <section className="relative py-20 sm:py-28 overflow-hidden">
      <div className="rounded-xl absolute inset-0 bg-gradient-to-br from-blue-50/50 via-indigo-50/30 to-purple-50/50 dark:from-blue-950/20 dark:via-indigo-950/10 dark:to-purple-950/20" />
      <div className="relative mx-auto max-w-6xl px-4">
        <div className="text-center max-w-4xl mx-auto">
          <Badge variant="secondary" className="mb-4 text-sm font-medium">
            <Star className="size-3 mr-1" />
            Science-Backed Assessment
          </Badge>
          <h1 className="text-4xl sm:text-6xl font-bold tracking-tight bg-gradient-to-r from-gray-900 to-gray-600 dark:from-gray-100 dark:to-gray-400 bg-clip-text text-transparent">
            Discover Your Key Emotional Motivators (KEMs)
          </h1>
          <p className="mt-6 text-lg sm:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            Unlock the deeper understanding of what truly drives you. Our research-based assessment tool reveals your unique emotional patterns and motivational drivers.
          </p>

          {children ? (
            <div className="mt-12">
              {children}
            </div>
          ) : null}

          {isAuthenticated ? (
            <div className="mt-10">
              <Link href="/dashboard">
                <Button size="lg" className="text-lg px-8 py-3 rounded-full">
                  Continue Your Journey
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
            </div>
          ) : (
            showAccessCards && (
              <div className="mt-12">
                <AccessCards />
              </div>
            )
          )}
        </div>
      </div>
    </section>
  );
}

